module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/NE-ec81306e024bc1857e94d2a548632226.png";